import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CaseViewState = {
  searchHistories: string[];
  searchPreferences: string[];
  checkedColumnKeys: string[];
  sortedColumnKeys: string[];
  itemsPerPage: 10 | 20 | 50 | 100;
  hasGroupNotExistsError: boolean;
};

export const initialState: CaseViewState = {
  searchHistories: [],
  searchPreferences: ['title', 'description', 'requester', 'number'],
  checkedColumnKeys: [],
  sortedColumnKeys: [],
  itemsPerPage: 20,
  hasGroupNotExistsError: false,
};

const caseView = createSlice({
  name: 'case-view',
  initialState,
  reducers: {
    setSearchHistories(state, action: PayloadAction<CaseViewState['searchHistories']>) {
      state.searchHistories = action.payload || initialState.searchHistories;
    },
    setSearchPreferences(state, action: PayloadAction<CaseViewState['searchPreferences']>) {
      state.searchPreferences = action.payload || initialState.searchPreferences;
    },
    setCheckedColumnKeys(state, action: PayloadAction<CaseViewState['checkedColumnKeys']>) {
      state.checkedColumnKeys = action.payload || initialState.checkedColumnKeys;
    },
    setSortedColumnKeys(state, action: PayloadAction<CaseViewState['sortedColumnKeys']>) {
      state.sortedColumnKeys = action.payload || initialState.sortedColumnKeys;
    },
    setItemsPerPage(state, action: PayloadAction<CaseViewState['itemsPerPage']>) {
      state.itemsPerPage = action.payload || initialState.itemsPerPage;
    },
    setHasGroupNotExistsError(state, action: PayloadAction<CaseViewState['hasGroupNotExistsError']>) {
      state.hasGroupNotExistsError = action.payload || initialState.hasGroupNotExistsError;
    },
  },
});

export const {
  setSearchHistories,
  setSearchPreferences,
  setCheckedColumnKeys,
  setSortedColumnKeys,
  setItemsPerPage,
  setHasGroupNotExistsError,
} = caseView.actions;
export default caseView.reducer;
